import { getGIA as r } from "./index26.js";
import { getNIA as n } from "./index38.js";
const g = (t) => {
  const e = r(t), o = n(t);
  return e - o;
};
export {
  g as getNonResidentialArea
};
//# sourceMappingURL=index39.js.map
